import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=40a5ae32&"
import script from "./TableCard.vue?vue&type=script&lang=js&"
export * from "./TableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports